"use client";

import { getContentfulImageUrl } from "../../../../helpers/contentful/images/getContentfulImageUrl";
import { useViewportDimensions } from "../../../../helpers/useViewportDimensions";
import { Kicker } from "../../../kicker/kicker";
import { CosmosButton } from "@cosmos/web-react";
import classnames from "classnames/bind";
import styles from "./company-teaser.module.css";

const cx = classnames.bind(styles);

const DESKTOP_WIDTH = 1000;

export const CompanyTeaser = ({
  imageUrl,
  preHeading,
  title,
  description,
  linkUrl,
  linkText,
}: {
  imageUrl: string | null;
  preHeading: string | null;
  title: string | null;
  description: string | null;
  linkUrl: string | null;
  linkText: string | null;
}) => {
  const { viewportWidth } = useViewportDimensions();

  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("main")}>
          <div className={cx("background")}>
            {imageUrl && (
              <img
                loading="lazy"
                className={cx("image")}
                sizes="(width >= 1250px) min(611px, 50vw), (width >= 1000px) min(66vw, 834px), 100vw"
                srcSet={[320, 360, 420, 611, 834]
                  .flatMap((width) =>
                    [1, 1.5, 2].map((multiplier) => width * multiplier),
                  )
                  .map(Math.ceil)
                  .map((width) => {
                    const url = getContentfulImageUrl(imageUrl, {
                      width,
                    });
                    return `${url} ${width}w`;
                  })
                  .join(", ")}
              />
            )}
          </div>
          <div className={cx("text")}>
            {(preHeading || title) && (
              <div className={cx("heading-group")}>
                {preHeading && (
                  <span className={cx("kicker-wrapper")}>
                    <Kicker
                      className={cx("kicker")}
                      kind="bare"
                      text={preHeading}
                    />
                  </span>
                )}
                <h2 className={cx("title")}>{title}</h2>
              </div>
            )}
            <p className={cx("description")}>{description}</p>
            <div className={cx("button-wrapper")}>
              <CosmosButton
                href={linkUrl ?? undefined}
                kind={viewportWidth < DESKTOP_WIDTH ? "tertiary" : "primary"}
                size="large"
                appearance="light"
                className={cx("button")}
              >
                {linkText}
              </CosmosButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
